module.exports = __webpack_public_path__ + "static/media/InterviewLogo.eb9e069a.svg";